require("!!/data/app/rdc-next/node_modules/script-loader/addScript.js")(require("!!/data/app/rdc-next/node_modules/raw-loader/index.js!/data/app/rdc-next/app/assets/javascripts/mortgage/v7/buy_vs_rent/buy_vs_rent_extra.js"))


// WEBPACK FOOTER //
// ./mortgage/v7/buy_vs_rent/buy_vs_rent_extra.js